import React, { useEffect, useState } from 'react';

import { UrlRouter } from './components/UrlRouter';
import { Authenticator } from './components/Auth/Authenticator';
import { AuthState, bootstrapAuth, onAuthUIStateChange } from './api';


const themes = {
  light: {
    outlineVariant: "outline-dark",
    onBodyButtonVariant: "dark"
  },
  dark: {
    outlineVariant: "outline-light",
    onBodyButtonVariant: "light"
  }
};
const isDarkMode = getComputedStyle(document.body).getPropertyValue('--isDarkMode');
export const ThemeContext = React.createContext((isDarkMode === "true") ? themes.dark : themes.light);

const App = () => {
  const [authState, setAuthState] = useState(AuthState.Loading);
  const [, setUser] = useState();

  useEffect(() => {
    bootstrapAuth();
    return onAuthUIStateChange((nextAuthState, authData) => {
      setAuthState(nextAuthState);
      setUser(authData);
    });
  }, []);

  return (
    <div
      className="App"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/DonutsColorful.png)`,
        backgroundSize: "400px"
      }}
    >
      <ThemeContext.Provider value={(isDarkMode === "true") ? themes.dark : themes.light}>
        <Authenticator>
          <UrlRouter authState={authState} />
        </Authenticator>
      </ThemeContext.Provider>
    </div>
  );
};

export default App;
